module.exports = __webpack_public_path__ + "img/horizontal-flip.49700d2f.svg";